import React from 'react';
import { Hero } from '../components/sections/Hero';
import { BeforeAfter } from '../components/sections/BeforeAfter';
import { PainPoints } from '../components/sections/PainPoints';
import { Volumes } from '../components/sections/Volumes';
import { Toolkit } from '../components/sections/Toolkit';
import { Bonuses } from '../components/sections/Bonuses';
import { Offer } from '../components/sections/Offer';
import { Guarantee } from '../components/sections/Guarantee';
import { Testimonials } from '../components/sections/Testimonials';
import { About } from '../components/sections/About';
import { Faq } from '../components/sections/Faq';
import { FinalCta } from '../components/sections/FinalCta';
import { Footer } from '../components/sections/Footer';
import { FloatingCta } from '../components/FloatingCta';
import { PurchasePopup } from '../components/PurchasePopup';
export function SalesPage() {
  return <div className="w-full min-h-screen bg-cream font-sans text-ink" data-id="element-289" data-mp="3vo2yn6pi40kp">
      <Hero data-id="element-290" data-mp="3ak8diam2xnpa" />
      <main data-id="element-291" data-mp="3ak02ko9iosgq">
        <BeforeAfter data-id="element-292" data-mp="3aki5u4ulk6y5" />
        <PainPoints data-id="element-293" data-mp="3al1cgpesr8wv" />
        <Volumes data-id="element-294" data-mp="35t03bccxdyb2" />
        <Toolkit data-id="element-295" data-mp="35shy3q8ac9r0" />
        <Bonuses data-id="element-296" data-mp="35ryrh5o357sa" />
        <Offer data-id="element-297" data-mp="35rf8dlmp8dco" />
        <Guarantee data-id="element-298" data-mp="35rowt4s3icg9" />
        <Testimonials data-id="element-299" data-mp="30twwpnhark0z" />
        <About data-id="element-300" data-mp="30tdr968u2o3u" />
        <Faq data-id="element-301" data-mp="30uyleur8k516" />
        <FinalCta data-id="element-302" data-mp="30uoqqtv8x9p5" />
      </main>
      <Footer data-id="element-303" data-mp="30rkgpfv3njqk" />
      <FloatingCta data-id="element-304" data-mp="2vutzuqbh0k43" />
      <PurchasePopup data-id="element-305" data-mp="2vvlmhbn3b7i8" />
    </div>;
}